import { Component, OnInit } from '@angular/core';
import { FieldConfig } from 'src/app/core/interfaces/field-config';
import { UntypedFormGroup } from '@angular/forms';
import { DynamicForm } from 'src/app/shared/error-messages';
import { DynamicFormServiceService} from 'src/app/shared/services/dynamic-form-service.service';
import moment from 'moment';
@Component({
    selector: 'app-datepicker-form',
    templateUrl: './datepicker-form.component.html',
    styleUrls: ['./datepicker-form.component.scss'],
    standalone: false
})
export class DatepickerFormComponent implements OnInit {

 constructor(private dynamicService: DynamicFormServiceService) { }
 field: FieldConfig;
 group: UntypedFormGroup;
 isRequired: boolean;
 currentMax = ['USDATE', 'BPDATE', 'MDOB'];
 currentDate = new Date();
 maxdate: Date;
 minDate = new Date(1000,0,1);
 ValidationMessages = {
   invalidDateFormat : DynamicForm.INVALID_DATE_FORMAT,
   dateValidation : DynamicForm.ENTER_VALID
 };

 ngOnInit() {
  if (this.currentMax.indexOf(this.field.labelCode) > -1) {
    this.maxdate = this.currentDate;
  } else if (this.field.labelCode === 'EDD') {
    this.minDate = this.currentDate;
    this.maxdate = moment(this.currentDate).add(1 , 'years').toDate();
  }
  this.isRequired = this.dynamicService.checkHasRequired(this.field);
 }
}
